import { convertUrl } from "../helpers/helper"
import { LowerResponse, Response } from "../types/backend.type"
import {
  ContactResponse,
  ContactResponseTaas,
  CreateContactResponse,
  CreateContactResponseTaas,
} from "../types/contactRetrieve.type"
import api from "../utils/api"
import http from "../utils/http"

// const contactRetrieveTaas = async (
//   token: string,
//   body: any,
//   randomstring: string
// ): Promise<Response<ContactResponseTaas>> => {
//   const response = await http.postTass(
//     convertUrl(`taasCustomerRetrieve`),
//     JSON.stringify(body),
//     token,
//     randomstring
//   )
//   return response
// }
const contactRetrieveTaas = async (
  token: string,
  body: any,
  randomstring: string
): Promise<Response<ContactResponseTaas>> => {
  const response = await http.postTass(
    convertUrl('retrieveCustomercontact'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}

const contactCreateTaas = async (
  token: string,
  body: any,
  randomstring: string
): Promise<Response<CreateContactResponseTaas>> => {
  const response = await http.postTass(
    convertUrl('createCustomercontact'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
} 

const createCTTTaas = async (token: string,
  body: any,
  randomstring: string
  ): Promise<Response<any>> => {
    const response = await http.postTass(
      convertUrl('createCustomercase'),
      JSON.stringify(body),
      token,
      randomstring
    )
    return response
  }

// const createCTTTaas = async (token: string, body: any) => {
//   const response = await http.post(
//     convertUrl(`creaateCTTTaas`),
//     JSON.stringify(body),
//     token,
//     undefined
//   )
//   return response
// }

const contactRetrieve = async (
  token: string,
  body: any
): Promise<Response<ContactResponse>> => {
  const response = await http.post(
    convertUrl(`novaCustomerRetrieve`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}

const contactCreate = async (
  token: string,
  body: any
): Promise<Response<CreateContactResponse>> => {
  const response = await http.post(
    convertUrl(`novaCustomerCreate`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}
const createSR = async (token: string, body: any) => {
  const response = await http.post(
    convertUrl(`createSRNova`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}
const createCTT = async (token: string, body: any) => {
  const response = await http.post(
    convertUrl(`creaateCTTNova`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}

export { contactRetrieve, contactCreate, createSR, createCTT,contactRetrieveTaas, contactCreateTaas, createCTTTaas }
